import { render, staticRenderFns } from "./ShareArrow.vue?vue&type=template&id=0b108dfb&"
import script from "./ShareArrow.vue?vue&type=script&lang=ts&"
export * from "./ShareArrow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports